import { THEMES } from '../../../constants';

/**
 * Premium presentation tools: Sora video, PPTX import, slide library.
 * Shown in local dev, or when the bundle is built with REACT_APP_PREMIUM_PRESENTATION_TOOLS=true (e.g. staging).
 */
export function showPremiumPresentationTools() {
  return (
    process.env.NODE_ENV === 'development' ||
    process.env.REACT_APP_PREMIUM_PRESENTATION_TOOLS === 'true'
  );
}

/** Presentations nav and routes: SpecByte, Audacy Flash, and Cash by Creative only — not CCC. */
export const PRESENTATIONS_THEME_KEYS = [
  THEMES.SPECBYTE,
  THEMES.CASHBYCREATIVE,
];

export function isPresentationsEnabledForTheme(themeKey) {
  return PRESENTATIONS_THEME_KEYS.includes(themeKey);
}
